import { createBrowserRouter } from "react-router-dom";
import AppHome from "../Pages/Home/AppHome";
import Pedidos from "../Components/Pedidos/Pedidos";
import Estoque from "../Components/Estoque/Estoque";
import Fornecedor from "../Components/Fornecedores/Fornecedor";
import LoginPage from "../Pages/Login/Login";
import Negocio from "../Components/Negocio/Negocio";
import GerenciarEstoque from "../Components/Estoque/GerenciarEstoque";
import PesquisarEstoque from "../Components/Estoque/PesquisarEstoque";
import Lotes from "../Components/Estoque/Lotes";
import GerarPedidos from "../Components/Pedidos/GerarPedidos";
import ConsultarPedidos from "../Components/Pedidos/ConsultarPedidos";
import Clientes from "../Components/Clientes/Clientes";
import CadastrarClientes from "../Components/Clientes/CadastrarClientes";
import ConsultarClientes from "../Components/Clientes/ConsultarClientes";
import CadastrarFornecedor from "../Components/Fornecedores/CadastrasFornecedor";
import ConsultarFornecedor from "../Components/Fornecedores/ConsultarFornecedor";
import Cadastros from "../Components/Cadastros/Cadastros";
import CNPJSearch from "../Components/Negocio/ConsultaCnpj";
import Graficos from "../Components/Graficos/Graficos";
import Generico from "../Components/Cadastros/Generico";
import GerarOrcamento from "../Components/Orcamentos/GerarOrcamento";
import ConsultarOrcamentos from "../Components/Orcamentos/ConsultarOrcamento";
import FormaPagamento from "../Components/Cadastros/FormaPagamento";
import RelatoriosPedidos from "../Components/Negocio/RelatoriosPedidos";
import RelatorioPedidosPorDiaSemana from "../Components/Negocio/RelatorioPedidosPorDiaSemana";
import RelatorioPedidosPorMes from "../Components/Negocio/RelatorioPedidosPorMes";
import RelatorioPedidosDetalhado from "../Components/Negocio/RelatorioPedidosDetalhado";
import Compras from "../Components/Estoque/Compras";


export const Router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/app",
    element: <AppHome />,
    children: [
      {
        path: "pedidos",
        element: <Pedidos />,
      },
      {
        path: "gerarpedidos/:pedidoId?",
        element: <GerarPedidos />,
      },
      {
        path: "consultarpedidos",
        element: <ConsultarPedidos />,
      },
      {
        path: "gerarorcamentos/:orcamentoId?",
        element: <GerarOrcamento />,
      },
      {
        path: "consultarorcamentos",
        element: <ConsultarOrcamentos />,
      },
      {
        path: "estoque",
        element: <Estoque />,
      },
      {
        path: "compras",
        element: <Compras />,
      },
      {
        path: "gerenciarestoque",
        element: <GerenciarEstoque />,
      },
      {
        path: "consultarestoque",
        element: <PesquisarEstoque />,
      },
      {
        path: "lotes",
        element: <Lotes />,
      },
      {
        path: "fornecedor",
        element: <Fornecedor />,
      },
      {
        path: "cadastrarfornecedor",
        element: <CadastrarFornecedor />,
      },
      {
        path: "consultarfornecedor",
        element: <ConsultarFornecedor />,
      },
      {
        path: "clientes",
        element: <Clientes />,
      },
      {
        path: "cadastrarclientes",
        element: <CadastrarClientes />,
      },
      {
        path: "consultarclientes",
        element: <ConsultarClientes />,
      },
      {
        path: "negocio",
        element: <Negocio />,
      },
      {
        path: "consultacnpj",
        element: <CNPJSearch />,
      },
      {
        path: "cadastros",
        element: <Cadastros/>        
      },
      {
        path: "cadastrogenerico",
        element: <Generico/>        
      },
      {
        path: "formasdepagamento",
        element: <FormaPagamento/>        
      },
      {
        path: "graficos",
        element: <Graficos/>        
      },
      {
        path: "relatorios-pedidos",
        element: <RelatoriosPedidos/>        
      },
      {
        path: "relatorio-pedidos-dia-semana",
        element: <RelatorioPedidosPorDiaSemana/>        
      },
      {
        path: "relatorio-pedidos-mes",
        element: <RelatorioPedidosPorMes/>        
      },
      {
        path: "relatorio-pedidos-detalhado",
        element: <RelatorioPedidosDetalhado/>        
      }
    ],
  },
]);